module.exports = __webpack_public_path__ + "static/media/9-aching-in-faith.e51d939.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/9-aching-in-faith.mp3
// module id = PdBz
// module chunks = 0